import { Button } from 'antd';
import FlexContainer from 'components/common/FlexContainer';
import { fontStyles } from 'styles/theme';
import styled from '@emotion/styled';

export const ButtonContainer = styled(FlexContainer)({
  minWidth: 164,
});

export const ViewCreditButton = styled(Button)({
  minHeight: 36,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
});

export const CreditPointsContainer = styled(FlexContainer)({
  textAlign: 'end',
});

export const CreditPointsNumber = styled.span({
  fontSize: fontStyles.sizes.lg,
  lineHeight: '26px',
  fontWeight: fontStyles.weights.medium,
  marginRight: '4px',
});
